import { shape, string } from 'prop-types'

const teamSmallType = shape({
  id: string,
  name: string,
  threeLetterIdentifier: string,
})

export default teamSmallType
